var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 0.25)",
    fill: "#1F1F26"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.25,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#303030"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2909 16.9047L9.58275 16.8541C8.70592 16.8365 7.8269 16.8717 6.96726 16.689C5.65955 16.416 5.56691 15.0774 5.46997 13.9545C5.33639 12.376 5.3881 10.7688 5.64018 9.20339C5.78248 8.32504 6.3425 7.80093 7.20856 7.7439C10.1321 7.53691 13.0751 7.56144 15.9922 7.65801C16.3003 7.66686 16.6105 7.71524 16.9143 7.77032C18.4138 8.03893 18.4504 9.55586 18.5476 10.8328C18.6445 12.123 18.6036 13.4198 18.4183 14.7011C18.2697 15.762 17.9853 16.6517 16.785 16.7376C15.2812 16.8499 13.8118 16.9404 12.3038 16.9116C12.3038 16.9047 12.2952 16.9047 12.2909 16.9047ZM10.6988 14.2188C11.832 13.5538 12.9437 12.9 14.0705 12.2395C12.9351 11.5745 11.8255 10.9207 10.6988 10.2602V14.2188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.92bdf1920851cbd66e113ab4c2b2f9c8.svg";
export { ForwardRef as ReactComponent };